// Centralized configuration for the WiFi Captive Portal

// API Configuration
export const API_CONFIG = {
  ENDPOINTS: {
    API: process.env.REACT_APP_API_ENDPOINT || 'https://apigw.thinkwifizone.com/api/v1',
    LOGS: process.env.REACT_APP_LOGS_ENDPOINT || 'https://logs.thinkwifizone.com'
  },
  BEARER_TOKEN: process.env.REACT_APP_API_BEARER_TOKEN || 'akljnv13bvi2vfo0b0bw',
  TIMEOUT: 10000, // 10 seconds
  MAX_RETRIES: 3
};

// Timeout Configuration (in milliseconds)
export const TIMEOUT_CONFIG = {
  VIDEO_AD_LOAD: 10000,        // Increased from 6s to 10s for slow networks
  VIDEO_AD_FAIL: 6000,          // Extended from 4s to 6s
  AUTHENTICATION_DELAY: 2000,
  PAGE_LOAD: 2000,
  DISPLAY_FOOTER: 3000,
  DISPLAY_ONLINE_FOOTER: 4000,
  CLOSE_AD_DELAY: 2000,
  REWARDED_AD_DISMISS: 3000,
  SCROLL_DELAY: 500,
  VIDEO_START_DELAY: 4000
};

// Ad Configuration
export const AD_CONFIG = {
  UNIT_CODES: {
    THINKZONE: '/21967555500/thinkzone/',
    THINKZONE_ADX: '/21967555500/thinkzoneAdX/'
  },
  ADX_PARTNERS: [
    'InterstateAdex',
    'SunsetAdex',
    'NETSWAN',
    'TuksAdex'
  ],
  PAGE_AD_UNITS: {
    PAGE_1: ['page1_header', 'page1_display', 'video_pri', 'online_header', 'online_display'],
    PAGE_2: ['page2_header', 'page2_display', 'video_sec', 'online2_header', 'online2_display']
  }
};

// Redirect Configuration
export const REDIRECT_CONFIG = {
  ALLOWED_DOMAINS: [
    'streamplay.digital',
    'www.streamplay.digital',
    'thinkwifizone.com',
    'www.thinkwifizone.com',
    'thinkwifi.online',
    'www.thinkwifi.online',
    'bit.ly'
  ],
  DEFAULT_URL: 'https://www.streamplay.digital/?utm_source=Think+Zone&utm_medium=Display+Ads&utm_campaign=CodeThink10&utm_term=Streamplay&utm_content=Get+The+App',
  FALLBACK_URL: 'https://thinkwifizone.com'
};

// WiFi Vendor Configuration
export const VENDOR_CONFIG = {
  SUPPORTED_VENDORS: ['ruckus', 'openwifi', 'cambium', 'mikrotik'],
  WIFI_PASSWORD: process.env.REACT_APP_WIFI_PASSWORD || 'Rl8zLPZ4w7L7',
  AUTH_DOMAINS: {
    SESSION_1: 'thinkzone',
    SESSION_2: 'thinkzone2'
  }
};

// Google Analytics Configuration
export const GA_CONFIG = {
  PRIMARY_TAG: 'G-H1XNVC8QDN',
  PARTNER_TAG: process.env.REACT_APP_GA4_TAG || null
};

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_RETRY: true,
  ENABLE_ERROR_TRACKING: false,  // Set to true when Sentry is configured
  ENABLE_ANALYTICS: true,
  ENABLE_AGE_CAP: true,
  ENABLE_OFFLINE_MODE: false,
  ENABLE_SERVICE_WORKER: false
};

// Prebid.js Configuration
export const PREBID_CONFIG = {
  TIMEOUT: 1500,                // Auction timeout in ms
  DEBUG: false,                 // Set true for verbose Prebid console logs
  PRICE_GRANULARITY: 'medium',
  SCRIPT_URL: '/prebid.js'     // Self-hosted in public/ folder
};

// Testing Configuration
export const TEST_CONFIG = {
  DEFAULT_PARTNER: 'TW',
  DEFAULT_DESCRIPTION: 'ThinkZone',
  DEFAULT_LSALE: 'default'
};
